module.exports = __webpack_public_path__ + "img/logo.75322b95.png";